var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHaidiMedicineIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 12,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m11.475 6.832-4.643 4.643a3.369 3.369 0 0 0 4.65-4.646l-.007.003ZM10.417 5.775a3.367 3.367 0 0 0-4.642 4.642l4.642-4.642Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m5.175 5.175-1.36-1.36 1.874-1.876a1.5 1.5 0 0 1 2.33 1.855c.2-.025.4-.039.6-.04.334.003.666.041.992.113A2.99 2.99 0 0 0 4.63.879l-3.75 3.75a2.99 2.99 0 0 0 2.977 4.982 4.835 4.835 0 0 1 1.319-4.436Z"
})));
export default SvgHaidiMedicineIcon;